import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-delete',
	path: '/secure/admin/ViewDeleteFieldScreen.jspa',
};
